import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Accordion from '../Accordion/Accordion';
import StatusIndicator from './StatusIndicator';
import {trackException} from '@forwardfinancing/analytics-frontend-library';

class Modal extends Component {
  static renderMessage({key=0, message, className}) {
    if (message && className) {
      return (
        <div key={key} className={`modal-component__${className}-line`}>
          {message}
        </div>
      );
    } else {
      return null;
    }
  }

  isPresentSimpleMessageList() {
    const { simpleMessageList } = this.props;

    return !!simpleMessageList;
  }

  mapMessage({content, className}) {
    if (Array.isArray(content)) {
      return content.map((message, key) => {
        return this.constructor.renderMessage({key, message, className});
      });
    }
  }

  renderModalContent({content, error}) {
    if (this.isPresentSimpleMessageList()) {
      return (
        <span className="modal-component__simple-message-list-content">
          {this.mapMessage({content, className: 'content'})}
          {this.mapMessage({content: error, className: 'error'})}
        </span>
      );
    } else {
      return (
        <div className="modal-component__message-list-content">
          <Accordion
            groups={content}
          />
        </div>
      );
    }
  }

  renderSpinner() {
    if (this.props.useSpinner) {
      return <div className="spinner" />;
    } else {
      return null;
    }
  }

  renderNavLinkButton() {
    const {desiredClassName, linkTo, error, onClose} = this.props;

    if (linkTo && linkTo.link) {
      return (
        <NavLink
          onClick={onClose}
          to={linkTo.link}
          className={`${desiredClassName} modal-component__content-link button ${error ? 'is-info' : 'is-primary'}`}
        >
          {linkTo.text}
        </NavLink>
      );
    } else {
      return null;
    }
  }

  renderCloseButton() {
    const {desiredClassName, useCloseButton, onClose, error} = this.props;
    if (useCloseButton) {
      return (
        <button
          onClick={onClose}
          className={`${desiredClassName}-close button ${error ? 'is-info' : 'is-primary'}`}
        >
          Close
        </button>
      );
    } else {
      return null;
    }
  }

  modalContent() {
    const {simpleMessageList, messageList} = this.props;

    return simpleMessageList ||  messageList;
  }

  reportExceptionModal() {
    const { isActive, error, type } = this.props;

    if (error && isActive) {
      const {errorMessageList} = this.props;
      const content = this.modalContent();

      if (type !== "user error") {
        trackException({errorInfo: errorMessageList});
      }

      return this.renderModalContent({error: errorMessageList, content});
    } else if (isActive) {
      const content = this.modalContent();

      return this.renderModalContent({content});
    }
  }

  renderIndicator() {
    const { withIndicator } = this.props;

     if (withIndicator) {
       const { error } = this.props;

       return (
         <div className={`modal-component__indicator`}>
           <div className={`modal-component__indicator-section`}>
             <StatusIndicator error={error}/>
           </div>
         </div>
       );
     }
  }

  renderConfirmationButtons(){
    const {onClose, onSubmit, desiredClassName} = this.props;
    if (onSubmit){
      return (
        <div className="modal-component__confirmation-buttons">
          <button
            onClick={onClose}
            className={`${desiredClassName}-close button is-info`}
          >
            Go Back
          </button>
          <button
            onClick={onSubmit}
            className={`${desiredClassName} button is-primary`}
          >
            Submit
          </button>
        </div>
      );
    }else{
      return null;
    }
  }

  render() {
    const { isActive, desiredClassName } = this.props;

    const topLevelClass =
      `${desiredClassName} modal-component modal ${isActive ? 'is-active' : ''}`;

    return (
      <div className={topLevelClass}>
        <div className={`modal-component__background modal-background`} />
        <div className={`modal-component__content modal-card`}>
          <div className={`modal-component__content-body modal-card-body`}>
            <div className={`modal-component__content-lines-wrap`}>
              {this.renderIndicator()}
              {this.reportExceptionModal()}
              {this.renderSpinner()}
              {this.renderNavLinkButton()}
              {this.renderConfirmationButtons()}
              {this.renderCloseButton()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  desiredClassName: PropTypes.string.isRequired,
  linkTo: PropTypes.object,
  simpleMessageList: PropTypes.array,
  errorMessageList: PropTypes.array,
  messageList: PropTypes.array,
  withIndicator: PropTypes.bool,
  error: PropTypes.bool,
  useCloseButton: PropTypes.bool,
  useSpinner: PropTypes.bool,
  onSubmit: PropTypes.func,
  type: PropTypes.string
};

Modal.defaultProps = {
  linkTo: null,
  useCloseButton: true,
  useSpinner: false,
  type: null
};

export default Modal;
